import { lazy } from "react";

export const lazyRetry = (importFn) =>
  lazy(
    () =>
      new Promise((resolve, reject) => {
        importFn()
          .then((component) => {
            sessionStorage.setItem("retry-lazy-refreshed", "false");
            resolve(component);
          })
          .catch((error) => {
            const hasRefreshed = JSON.parse(
              sessionStorage.getItem("retry-lazy-refreshed") || "false",
            );
            if (!hasRefreshed) {
              sessionStorage.setItem("retry-lazy-refreshed", "true");
              return window.location.reload();
            }
            reject(error);
          });
      }),
  );
